import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { Redirect } from 'react-router-dom';

import { api_crud_base, api_crud_route, data_interface, endpoints } from './Config';
//import ASSEC_CKEditor from "../../../ASSEC_CKEditor/ASSEC_CKEditor";

import { getTokenInfo } from '../../../../UseToken';

import Loader from '../../../Loader/Loader';

import Swal from 'sweetalert2'

import { language } from './Language';

import {

	reqGET,
	reqPOST,
	reqDELETE,
	reqPUT,
	content_language,

} from '../../../../Utils';
//import { get } from 'core-js/core/dict';

export default function Regist(props) {
	const [, set_dados] = useState(null);
	const dados = useRef(null);

	const [lang, set_lang] = useState('pt');

	const [isloading, setLoading] = useState(true);
	const [isRedirect, setRedirect] = useState(false);
	
	const [refresh, setRefresh] = useState(0);

	const [zones, set_zones] = useState([]);

	const [show_delete_button, set_show_delete_button] = useState(false);

	/*const editor = useRef(null)
	const config = {
        readonly: false // all options from https://xdsoft.net/jodit/doc/
    }*/

	//const [disabled, set_disabled] = useState(true)

	const [is_edit, set_is_edit] = useState(false)

	const fetch_id_info = async (id_serch) => {

		return await reqGET(`${api_crud_route}/${getTokenInfo().companycode}/${id_serch}`)
			.then(res => {
				set_dados(dados.current = res.data[0]);

			})
			.catch(error => console.log(error)/*TODO: GO TO FAIL FETCH*/)
	}

	const get_zones = async () => {

		return await reqGET(`${api_crud_base}/store/zone/shipping/${getTokenInfo().companycode}`)
			.then(res => {
				set_zones(res.data);
			})
			.catch(error => console.log(error)/*TODO: GO TO FAIL FETCH*/)

	}

	const clean_data = () => {
		// DEEP COPY OF data_interface 
		set_dados(dados.current = JSON.parse(JSON.stringify(data_interface)))
		set_dados(dados.current.info.companycode = getTokenInfo().companycode)
		//console.log(dados.current)
	}

	useEffect(() => {
		clean_data();

        set_lang(localStorage.getItem('lang'))

		get_zones()

		try {
			let test = props.location.state.operation;
			
			if (test === 'edit') {
				//set_disabled(true)

				set_is_edit(true)

				set_show_delete_button(true)

				fetch_id_info(props.location.state.item['id']).then(() => {
					setLoading(false)
				})
				return
			}
			else {
				setLoading(false)
			}

		} catch {
			clean_data()

			setLoading(false);

			setRedirect(false);
			return
		}

		return () => {
			clean_data()
		}

	}, [props])

	const handleSubmit = async e => {
		e.preventDefault();

		if (is_edit === true) {

			Swal.fire({
				title: language[lang].edit_title,
				text: language[lang].edit_text,
				icon: 'question',
				showCancelButton: true,
				confirmButtonColor: '#0095e8',
				cancelButtonColor: '#d9214e',
				confirmButtonText: language[lang].edit_confirm,
				cancelButtonText: language[lang].edit_cancel
			})
			.then((result) => {
				if (result.isConfirmed) {
					reqPUT(api_crud_route, dados.current)
						.then(() => { 
							//props.history.push(endpoints.list) 
						})
						.catch(() => Swal.fire(language[lang].edit_error, '', 'info'))
				}
			})

		} else {

			Swal.fire({
				title: language[lang].insert_title,
				text: language[lang].insert_text,
				icon: 'question',
				showCancelButton: true,
				confirmButtonColor: '#0095e8',
				cancelButtonColor: '#d9214e',
				confirmButtonText: language[lang].insert_confirm,
				cancelButtonText: language[lang].insert_cancel
			})
			.then((result) => {
				if (result.isConfirmed) {
					reqPOST(api_crud_route, dados.current)
						.then(() => { 
							props.history.push(endpoints.list) 
						})
						.catch(() => Swal.fire(language[lang].insert_error, '', 'info'))
				}
			})

		}
	}

	function apagar() {
		Swal.fire({
			title: language[lang].delete_title,
			text: language[lang].delete_text,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].delete_confirm,
			cancelButtonText: language[lang].delete_cancel
		})
		.then((result) => {
			if (result.isConfirmed) {
				reqDELETE(api_crud_route, { id: dados.current.id })
					.then(() => {
						props.history.push(endpoints.list);
					})
					.catch(error => console.log(error))
			}
		})
		.catch((erro) => {
			console.log(erro)
		})
		
	};

	const handle_change_info = (e) => {
		const { name, value, dataset } = e.target;
		const { /*order,*/ lang, langid } = dataset

		if(langid === '1') {
			set_dados(dados.current.info[name] = value)
		}
		else {
			if(dados.current.info['language'] === undefined)
				dados.current.info['language'] = []

			if(dados.current.info.language.length  === 0) {
				//dados.current.info.language[lang] = {id: langid, code: lang, title: '', abstract: '', text: ''}
				dados.current.info.language[langid] = {id: langid, code: lang, name: '', description: '', media: {image: [], doc: []}}
			}

			set_dados(dados.current.info['language'][langid][name] = value)
		}

		if(name === 'bgColor')
			set_dados(dados.current.info.borderColor = value)

		// console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		// console.log('Dados Current:' + JSON.stringify(dados))
	}

	const handle_change_info_free_shipping = (e) => {
		const { name, value } = e.target;

		set_dados(dados.current.info.free_shipping[name] = value)
	}

	/*const handle_change_info_description = (e) => {
		set_dados(dados.current.info['description'] = e)
	}*/

	/*const handle_change_info_ckeditor = (value, order, langid, lang, name) => {

		console.log('handle_change_info_ckeditor', value);

		if (langid === '1') {
			set_dados(dados.current.info[name] = value)
		}
		else {
			if (dados.current.info['language'] === undefined)
				dados.current.info['language'] = []

			if (dados.current.info.language.length === 0) {
				dados.current.info.language[langid] = { id: langid, code: lang, name: '', description: '' }
			}

			set_dados(dados.current.info['language'][langid][name] = value)
		}

		console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		console.log('Dados Current:' + JSON.stringify(dados))
	}*/

	/*const handleSingleCheck = e => {
		const { name } = e.target;

		set_dados(dados.current.info[name] = !dados.current.info['status'])
	}*/

	const get_value_info_lang = (langid, name) => {
		if(dados.current.info['language'] !== undefined && dados.current.info['language'] !== null) {
			if(dados.current.info['language'][langid] !== undefined && dados.current.info['language'][langid] !== null) {
				return dados.current.info['language'][langid][name];
			}
			else {
				return '';
			}
		}
		else {
			return '';
		}
	}

	const add_ranges = (min) => {
		dados.current.info.ranges.push({
			min: min,
			max: (parseFloat(min) + 1),
			values: JSON.parse(JSON.stringify(dados.current.info.ranges[dados.current.info.ranges.length - 1].values))
		})

		setRefresh(refresh + 1)
		// set_dados(dados.current.info['ranges'] = dados.current.info['ranges'])

		// console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		// console.log('Dados Current:' + JSON.stringify(dados.current.info.ranges))
	}

	const remove_last_range = () => {
		dados.current.info.ranges.pop()

		setRefresh(refresh + 1)
	}

	const handleSelectZone = e => {
		const { dataset } = e.target;
		const { id } = dataset

		if(dados.current.info['ranges'] === undefined) {
			dados.current.info['ranges'] = [{
				min: '0',
				max: '1',
				values: []
			}]
		}

		dados.current.info.ranges.forEach((el) => {
			if(el.values.length === 0) {
				el.values.push({
					id: id,
					status: true,
					value: ''
				})
			}
			else {
				let i = 0
				el.values.forEach((el_v) => {
					if(el_v.id === id) {
						i++
						if(el_v.status === true) {
							el_v.status = false
							el_v.value = ''
						}
						else {
							el_v.status = true
							el_v.value = ''
						}
					}
				})

				if(i === 0) {
					el.values.push({
						id: id,
						status: true,
						value: ''
					})
				}
			}
		})

		set_dados(dados.current.info['ranges'], )

		console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		console.log('Dados Current:' + JSON.stringify(dados.current.info.ranges))
	}

	const handleRangeCheckVerify = (id) => {
		let result = false
		dados.current.info.ranges.forEach((el) => {	
			el.values.forEach((el_v) => {
				if(el_v.id === id) {
					result = true
				}
			})
		})
		return result
	}

	const handle_change_info_ranges = (e) => {
		const { name, value, dataset } = e.target;
		const { order } = dataset

		if(value < 0) {

		}
		else {
			if(name === 'min' && parseInt(order) === 0) {

				// obrigatório começar em 0

			}
			else if(name === 'max' && parseInt(order) === 0 && value < 0) {

				// obrigatório ser maior do que 0

			}
			else if(name === 'min' && parseInt(order) > 0) {

				dados.current.info.ranges[parseInt(order) - 1]['max'] = value
				dados.current.info.ranges[order][name] = value

			}
			else if(name === 'max' && parseInt(order) < parseInt(dados.current.info.ranges.length - 1)) {

				dados.current.info.ranges[order][name] = value
				dados.current.info.ranges[parseInt(order) + 1]['min'] = value

			} 
			else {

				dados.current.info.ranges[order][name] = value
			
			}
		}

		set_dados(dados.current.info.ranges[order][name], )
	}

	const handle_change_info_ranges_values = (e) => {
		const { value, dataset } = e.target;
		const { order, zoneid } = dataset

		dados.current.info.ranges[order]['values'].forEach((el) => {
			if(el.id === zoneid) {
				el.value = value
			}
		})

		setRefresh(refresh + 1)

		// console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		// console.log('Dados Current:' + JSON.stringify(dados.current.info.ranges))

	}

	const get_zone_range_value = (order, zoneid) => {
		let result = ''
		dados.current.info.ranges[order]['values'].forEach((el) => {
			if(el.id === zoneid) {
				result = el.value
			}
		})
		return result
	}

	return isloading ?
		
		<Loader />

		:
		isRedirect
			?
			<Redirect to={endpoints.list} replace />
			:

			<main>
				<div className={`dash-cards header`}>
					<h2 className="dash-title">{language[lang].shipping_preferences}</h2>
				</div>
		
				<div className={`dash-cards body`}>
					<div className="container">
						<div className="row">
		
							<div className="mb-5 mb-xl-10">
								<div className="card">
									
									<div className="card-header border-0 d-flex justify-content-sm-between" data-bs-target="#div_entidade_info" aria-expanded="true" aria-controls="div_entidade_info">
										<div className="card-title m-0">
											<h3 className="fw-bolder m-0">{language[lang].config}</h3>
										</div>
										<div className="card-toolbar">
											<ul className="nav nav-tabs nav-line-tabs nav-stretch fs-6 border-0">
												{
												content_language.length > 1 && 0 ?
													content_language.map((el_lang, k_lang) => {
														return (
															<li key={k_lang} className="nav-item">
																<a className={"btn btn-sm btn-secondary rounded-0 multi-item" + (k_lang === 0 ? " active" : "")} data-bs-toggle="tab" href={"#div_tab_pane_content_language_" + k_lang}>{el_lang.code}</a>
															</li>
														)
													})
												:
													''
												}
											</ul>
										</div>
									</div>
									<div id="div_entidade_info" className="collapse show">
										
										<form id="form" onSubmit={handleSubmit}>
											<div className="card-body border-top p-4">

												<div className="tab-content" id={"tab_entidade_lang"} >
													{
													content_language.length > 1 ?
														content_language.map((el_lang, k_lang) => {
															if(k_lang === 0) {
																return (
																	<div key={k_lang} className={"tab-pane" + (k_lang === 0 ? " show active" : '')} id={"div_tab_pane_content_language_" + k_lang} role="tabpanel">
																		<div className="row mb-3">
																			<div className="col-md-4 text-end">
																				<label className={el_lang.id === '1' ? "fs-5 required mb-2" : "fs-5 mb-2"}>{language[lang].field_name} {k_lang > 0 ? '(' + el_lang.code + ')' : ''}</label>
																			</div>
																			<div className="col-md-6">
																				<input type="text" name="name" data-langid={el_lang.id} data-lang={el_lang.code} value={el_lang.id === '1' ? dados.current.info.name : get_value_info_lang(el_lang.id, 'name')} className="form-control rounded-0" placeholder={language[lang].field_name_placeholder} onChange={handle_change_info} required={el_lang.id === '1' ? 'required' : ''} />
																			</div>
																		</div>

																		<div className="row mb-3">
																			<div className="col-md-4 text-end">
																				<label className="fs-5 mb-0">{language[lang].field_handling_charges}</label>
																			</div>
																			<div className="col-md-3">
																				<div className="input-group">
																					<input type="text" name="handling_charges" data-langid={el_lang.id} data-lang={el_lang.code} value={dados.current.info.handling_charges} className="form-control rounded-0 text-end" placeholder={language[lang].field_handling_charges_placeholder} onChange={handle_change_info} />
																					<div className="input-group-text rounded-0 py-2 px-3">
																						<i className="bi bi-currency-euro"></i>
																					</div>
																				</div>
																			</div>
																		</div>

																		<div className="row mb-3">
																			<div className="col-md-4 text-end">
																				<label className="fs-5 mb-0">{language[lang].field_free_shipping}</label>
																			</div>
																			<div className="col-md-3">
																				<div className="input-group">
																					<input type="text" name="value" data-langid={el_lang.id} data-lang={el_lang.code} value={dados.current.info.free_shipping.value} className="form-control rounded-0 text-end" placeholder={language[lang].field_free_shipping_placeholder} onChange={handle_change_info_free_shipping} />
																					<div className="input-group-text rounded-0 py-2 px-3">
																						<i className="bi bi-currency-euro"></i>
																					</div>
																				</div>
																			</div>
																			<div className="col-md-3">
																				<div className="input-group">
																					<input type="text" name="weight" data-langid={el_lang.id} data-lang={el_lang.code} value={dados.current.info.free_shipping.weight} className="form-control rounded-0 text-end" placeholder={language[lang].field_free_shipping_placeholder} onChange={handle_change_info_free_shipping} />
																					<div className="input-group-text rounded-0 py-2 px-3">
																						kg
																					</div>
																				</div>
																			</div>
																		</div>

																		<div className="row mt-5 mb-3">
																			<div className="col-12">
																				<h3 className="fs-5 mb-3">{language[lang].field_ranges} {k_lang > 0 ? '(' + el_lang.code + ')' : ''}</h3>
																			</div>
																		</div>

																		<div className="row mb-3">
																			<div className="col-12">
																				<button type="button" className='btn btn-sm btn-secondary rounded-0' onClick={() => add_ranges(dados.current.info.ranges[dados.current.info.ranges.length - 1].max)}>{language[lang].new_range}</button>
																				{
																				dados.current.info.ranges.length > 1 ?
																					<button type="button" className='btn btn-sm btn-secondary rounded-0 ms-2' onClick={() => remove_last_range()}>{language[lang].remove_last}</button>
																				:
																					''
																				}
																			
																				<table>
																					<thead>
																						<tr>
																							<td></td>
																							{
																							dados.current.info.ranges.map((element, key) => {
																								return (
																									<td key={key} style={{maxWidth: '250px'}}>
																										<div className=''>
																											<div className="input-group input-group-sm">
																												<input className='form-control rounded-0 text-end' name='min' data-order={key} value={element.min} onChange={(e) => handle_change_info_ranges(e)} />
																												<div className="input-group-text rounded-0 py-2 px-3">
																													{language[lang].to}
																												</div>
																												<input className='form-control rounded-0 text-end' name='max' data-order={key} value={element.max} onChange={(e) => handle_change_info_ranges(e)} />
																												<div className="input-group-text rounded-0 py-2 px-3">
																													kg
																												</div>
																											</div>
																										</div>
																									</td>
																									)
																								})
																							}
																						</tr>
																					</thead>
																					<tbody>
																						{
																						zones.map((element_zones, key_zones) => {
																							return (
																								<tr key={key_zones}>
																									<td>
																										<div className="form-check">
																											<label className="form-check-label text-nowrap" htmlFor={"zone_" + key_zones}>
																												{element_zones.info.name}
																											</label>
																											<input 
																												id={"zone_" + key_zones}
																												value=""
																												type="checkbox" 
																												className='form-check-input rounded-0' 
																												data-id={element_zones.id}
																												data-order={key_zones}
																												onChange={handleSelectZone}
																												defaultChecked={handleRangeCheckVerify(element_zones.id)}
																											/>
																										</div>
																									</td>
																									{
																									dados.current.info.ranges.map((element, key) => {
																										return (
																											<td key={key} style={{maxWidth: '250px'}}>
																												<div className="input-group input-group-sm">
																													<input className='form-control rounded-0 text-end' data-order={key} data-zoneid={element_zones.id} data-zone={key_zones} data-min={element.min} data-max={element.max} value={get_zone_range_value(key, element_zones.id)} onChange={(e) => handle_change_info_ranges_values(e)} />
																													<div className="input-group-text rounded-0 py-2 px-3">
																														<i className="bi bi-currency-euro"></i>
																													</div>
																												</div>
																											</td>
																										)
																									})
																								}
																								</tr>
																							)
																						})
																						}
																					</tbody>
																				</table>

																			</div>
																		</div>
																	</div>
																)
															} else return ''
														})
													:
														null
													}
												</div>

											</div>
										</form>

									</div>
								</div>
							</div>

						</div>
					</div>
				</div>

				<div className={'dash-cards footer'}>
					<nav className="navbar bottom-navbar navbar-light">
						<div className="navbar-footer">
							<ul className="navbar-nav float-left"></ul>
							<ul className="navbar-nav float-right">
								<li className="nav-item">
									<Link className="nav-link btn-cancel" to={{ pathname: endpoints.list }}  >
										<img alt='' src={'./img/cancelar.svg'} />
										<span>{language[lang].cancel}</span>
									</Link>
								</li>
								<li className={"nav-item " + show_delete_button}>
									<button type="button" onClick={() => apagar(dados.current.id)} className="nav-link btn-delete">
										<img alt='' src={'./img/eliminar_b.svg'} />
										<span>{language[lang].delete}</span>
									</button>
								</li>
								<li className="nav-item">
									<button type="submit" form="form" className="nav-link">
										<img alt='' src={'./img/save.svg'} />
										<span>{language[lang].save}</span>
									</button>
								</li>
							</ul>
						</div>
					</nav>
				</div>
			</main>
}
